import { I18n } from "@assets/strings";
import moment from "moment";
import React from "react";
import styled from "styled-components";
import checkIcon from "@assets/images/check.svg";
import { useServices } from "@core/servicesContext";
import { useCurrentProfile } from "@domain/currentProfile/hooks";
import { Group } from "@domain/group/group";
import { Disbursement } from "@domain/wallet/wallet";
import { DisbursementType } from "@domain/wallet/walletDraft";
import { useModalTools } from "@ui/modals/modalContext";
import { LoadingButton } from "@ui/components/buttons/loadingButton";
import { Primary } from "@ui/components/containers/primary";
import { ShareroomCashout } from "@ui/components/group/shareroom/dashboard/shareroomCashout";

interface DisbursementListProps extends React.HTMLAttributes<HTMLDivElement> {
	disbursementList: Disbursement[] | null;
	shareroom: Group;
}

export const DisbursementList: React.FC<DisbursementListProps> = ({ disbursementList, shareroom }) => {
	const { createModal } = useModalTools();
	const currentProfile = useCurrentProfile();
	const { trackingService } = useServices();
	// const showModalCashout = (): any => {
	// 	close();
	// 	createModal((close) => <ShareroomCashout shareroom={shareroom} close={close} />);
	// };
	return (
		<>
			{disbursementList ? (
				<>
					{disbursementList.map((item) => (
						<StyledItem key={item.month}>
							<LeftBloc>
								<StyledAmount>
									{item.unitPrice} {currentProfile?.currency}
								</StyledAmount>
								<StyledPeriodicity>
									{moment(item.startDate).format("LL")} au {moment(item.endDate).format("LL")}
								</StyledPeriodicity>
							</LeftBloc>
							<MediumBloc>
								<StyledBalance>
									{item.cashableIUC} {currentProfile?.currency}
								</StyledBalance>
							</MediumBloc>
							<RightBloc>
								{item.status === DisbursementType.WITHDRAWN ? (
									<StyledContainerWithdrawn>
										<StyledTextRetired>
											{I18n.t("shareroom.dashboard.transactions.table.withdrawn_button.label")}
										</StyledTextRetired>
										<StyledIcon>
											<img src={checkIcon} />
										</StyledIcon>
									</StyledContainerWithdrawn>
								) : (
									<StyledButtonAction
										disabled={item.status !== DisbursementType.WITHDRAWABLE}
										onClick={() => {
											trackingService.track("Disbursement / teacher");
											createModal((close) => (
												<ShareroomCashout
													shareroom={shareroom}
													cashableIUC={item.cashableIUC}
													month={item.month ?? null}
													close={close}
												/>
											));
										}}
									>
										<span>{I18n.t("shareroom.dashboard.transactions.table.withdraw_button.label")}</span>
									</StyledButtonAction>
								)}
							</RightBloc>
						</StyledItem>
					))}
				</>
			) : null}
		</>
	);
};

const StyledItem = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 30px;
	line-height: 16px;
`;
const LeftBloc = styled.div`
	flex-direction: column;
`;
const MediumBloc = styled.div``;
const RightBloc = styled.div``;

const StyledAmount = styled(Primary)`
	font-weight: 700;
	font-size: 12px;
	color: #206af8;
`;
const StyledPeriodicity = styled(Primary)`
	font-weight: 400;
	font-size: 8px;
`;
const StyledBalance = styled(Primary)`
	font-size: 10px;
	color: rgba(52, 200, 15, 0.8);
`;
const StyledButtonAction = styled(LoadingButton)`
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	padding: 5px 18px;
	gap: 10px;
	font-size: 10px;
	line-height: 13px;
	background: rgba(32, 106, 248, 0.2);
	color: #206af8;
	:hover {
		background-color: rgba(32, 106, 248, 0.2);
	}
	/* width: 54%; */
`;
const StyledContainerWithdrawn = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
`;
const StyledTextRetired = styled.div`
	font-weight: 500;
	font-size: 14px;
	line-height: 18px;
	color: rgba(1, 1, 1, 0.5);
`;
const StyledIcon = styled.div`
	margin-left: 10px;
`;
